import type { LogoCarouselItem } from '../components/LogoCarousel/LogoSlide/LogoSlide';

export const featuredLogo: LogoCarouselItem[] = [
  {
    id: 'coinDesk',
    title: 'CoinDesk',
    href: 'https://www.coindesk.com/business/2024/03/06/web3-app-store-magic-square-unveils-66m-grant-program',
    defaultLogoUrl: '/magicsquare/landing/featuredLogo/CoinDesk.png',
    hoverLogoUrl: '/magicsquare/landing/featuredLogo/CoinDeskHover.png',
    width: 176,
    isExternalLink: true,
  },
  {
    id: 'coinTelegraph',
    title: 'CoinTelegraph',
    href: 'https://cointelegraph.com/news/magic-square-ido-platform-democratizes-retail-access',
    defaultLogoUrl: '/magicsquare/landing/featuredLogo/CoinTelegraph.png',
    hoverLogoUrl: '/magicsquare/landing/featuredLogo/CoinTelegraphHover.png',
    width: 187,
    isExternalLink: true,
  },
  {
    id: 'techCrunch',
    title: 'TechCrunch',
    href: 'https://techcrunch.com/2022/10/11/magic-square-web3-app-store-apple/',
    defaultLogoUrl: '/magicsquare/landing/featuredLogo/TechCrunch.png',
    hoverLogoUrl: '/magicsquare/landing/featuredLogo/TechCrunchHover.png',
    width: 227,
    isExternalLink: true,
  },
  {
    id: 'theBlock',
    title: 'The Block',
    href: 'https://www.theblock.co/post/278843/web3-app-store-magic-square-acquires-token-launchpad-truepnl',
    defaultLogoUrl: '/magicsquare/landing/featuredLogo/TheBlock.png',
    hoverLogoUrl: '/magicsquare/landing/featuredLogo/TheBlockHover.png',
    width: 223,
    isExternalLink: true,
  },
];
